import type { PropsWithChildren } from 'react';
import { PageButton, PageItem, Wrapper } from './styles';
export { Pagination, Slide, Slides } from './styles';

interface PageProps {
  isActive: boolean;
  onClick: () => void;
  'data-testid'?: string;
}

export function Page({ isActive, onClick, 'data-testid': dataTestId }: PageProps) {
  return (
    <PageButton onClick={onClick} data-testid={dataTestId} data-active={isActive}>
      <PageItem isActive={isActive} />
    </PageButton>
  );
}

export function Slider({ children, 'data-testid': dataTestId }: PropsWithChildren<{ 'data-testid'?: string }>) {
  return <Wrapper data-testid={dataTestId}>{children}</Wrapper>;
}
